import { API_URL, PRICE_SCHEME_HEADER, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

/**
 * Deletes a price rule by its ID.
 *
 * @param {string} priceRuleId - The ID of the price rule to delete.
 *
 * @returns {Promise<void>} A promise that resolves when the deletion is successful.
 * @throws {Error} If the deletion fails, an error is thrown.
 */
export const deletePriceRule = async (priceRuleId: string, priceSchemeId: string): Promise<void> => {
  const url = `${API_URL}/pricing/price-rules/${priceRuleId}`;
  const res = await fetch(url, {
    method: 'DELETE',
    headers: {
      [PRICE_SCHEME_HEADER]: priceSchemeId,
    },
  });
  if (res.status === Status.BAD_REQUEST || res.ok === false) {
    throw new Error('Unable to delete Pricing Rule. Please try again');
  }
};
